import { oc } from "@orpc/contract";
import { GoodVibesGranularitySchema, GoodVibesHistoryPointSchema } from "@domains/good-vibes/shared/goodVibesHistory.ts";
import { GoodVibesTimeFrameSchema } from "@domains/good-vibes/shared/goodVibesTimeFrame.ts";
import { GoodVibesVisibilitySchema } from "@domains/good-vibes/shared/goodVibesVisibility.ts";
import { ReportingScopeSchema } from "@packages/core/organization/scope.ts";
import { z } from "zod";

const GoodVibesHistoryInputSchema = z.object({
    scope: ReportingScopeSchema.optional(),
    timeFrame: GoodVibesTimeFrameSchema.optional(),
    visibility: GoodVibesVisibilitySchema.optional()
});

const GoodVibesHistorySchema = z.object({
    totalReceived: z.number(),
    totalReceivedDeltaPercent: z.number().nullable(),
    trendGranularity: GoodVibesGranularitySchema,
    trendPoints: z.array(GoodVibesHistoryPointSchema)
});
export type GoodVibesHistory = z.infer<typeof GoodVibesHistorySchema>;

export const goodVibesContract = {
    getGoodVibesHistory: oc.route({ method: "GET", path: "/history" }).errors({ UPSTREAM_FAILURE: {} }).input(GoodVibesHistoryInputSchema).output(GoodVibesHistorySchema)
};
